export function splitPascalCase(value: string): string {
  return value.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
}

export function enumToFilterFields<T extends object>(
  enumObj: T,
  formatLabel: (key: string) => string = (key) => key,
): { name: string; value: number }[] {
  return Object.keys(enumObj)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
      name: formatLabel(key),
      value: (enumObj as any)[key],
    }));
}
